import React from 'react';
import '../../../../css/common/chat/ChatMentionTaskNotice.css';

const ChatMentionTaskNotice = ({
  count = 0,
  onResolve,
  onOpen,
  disabled = false,
  className = '',
}) => {
  const safeCount = Number(count || 0);
  if (safeCount <= 0) return null;
  const countLabel = safeCount > 99 ? '99+' : String(safeCount);
  const canOpen = safeCount === 1 && typeof onOpen === 'function' && !disabled;

  const handleResolveClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (disabled || typeof onResolve !== 'function') return;
    onResolve();
  };
  const handleOpen = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!canOpen) return;
    onOpen();
  };
  const handleKeyDown = (event) => {
    if (!canOpen || (event.key !== 'Enter' && event.key !== ' ')) return;
    handleOpen(event);
  };

  return (
    <div
      className={[
        'chat-mention-task-notice',
        disabled ? 'is-disabled' : '',
        className,
      ].filter(Boolean).join(' ')}
      onClick={handleOpen}
      onKeyDown={handleKeyDown}
      role={canOpen ? 'button' : 'group'}
      tabIndex={canOpen ? 0 : undefined}
      aria-label="未対応メンションのお知らせ"
    >
      <span className="chat-mention-task-notice__alert" aria-hidden="true">
        <i className="fa-solid fa-triangle-exclamation" aria-hidden="true" />
      </span>
      <span className="chat-mention-task-notice__text">
        <span className="chat-mention-task-notice__label">メンションがあります</span>
      </span>
      <button
        type="button"
        className="chat-mention-task-notice__box"
        disabled={disabled}
        onClick={handleResolveClick}
        aria-label="メンションを対応済みにする"
      >
        {safeCount > 1 ? (
          <span className="chat-mention-task-notice__box-count">{countLabel}</span>
        ) : (
          <i className="fa-solid fa-check" aria-hidden="true" />
        )}
      </button>
    </div>
  );
};

export default ChatMentionTaskNotice;
